module.exports = __webpack_public_path__ + "static/media/Car-red.be2e9b15.svg";